import { render, staticRenderFns } from "./discount-coupon.vue?vue&type=template&id=0c98694f&"
import script from "./discount-coupon.vue?vue&type=script&lang=ts&"
export * from "./discount-coupon.vue?vue&type=script&lang=ts&"
import style0 from "./discount-coupon.vue?vue&type=style&index=0&id=0c98694f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports